import { render, staticRenderFns } from "./OverPriceSms.vue?vue&type=template&id=12dda64f&"
import script from "./OverPriceSms.vue?vue&type=script&lang=ts&"
export * from "./OverPriceSms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports